export const TABLE_EXPORT_PAGE = "table-export";
export const TABLE_EXPORT_PATH = `${TABLE_EXPORT_PAGE}`;
